import React, { useEffect, useRef } from 'react';
import EventManagementHero from './EventManagementHero/EventManagementHero';
import AboutEventManagement from './AboutEventManagement/AboutEventManagement';
import EventPortfolioPart from './EventPortfolioPart/EventPortfolioPart';
import EventManagementDetails from './EventManagementDetails/EventManagementDetails';
import WithUs from '../../Landing/WithUs/WithUs';
import Footer from '../../../Components/Footer/Footer';
import SeoHelmet from '../../../Components/SeoHelmet';

const EventManagementLanding = () => {
  const scrollRef = useRef(null)
  useEffect(()=>{
    scrollRef.current.scrollIntoView()
  }
,[])
  return (
    <div className='overflow-hidden'>
      <div ref={scrollRef}></div>
      <SeoHelmet
        title="SunMed | Event Management"
        description="At Sun Med, we believe that every event is more than just a moment,
        it’s an experience that tells a story. Our philosophy in event
        management blends technical precision with creative vision, ensuring
        that every detail from setup to live streaming works seamlessly to
        captivate your audience."
        keywords="SunMed, media production, web solutions, digital marketing, education, event management"
        url="https://sunmed.com"
        image="https://sunmed.com/images/sunmed-home-og.jpg"
      />
      <EventManagementHero/>
      <AboutEventManagement/>
      <EventPortfolioPart/>
      <EventManagementDetails/>
      <WithUs/>
      <Footer/>
    </div>
  );
}

export default EventManagementLanding;
